import { createStore } from 'redux';
import rootReducer from './reducers/preview';

export const store = createStore(rootReducer);
